export const SIGN_UP = 'auth/signup'
export const SIGN_UP_BEGIN = 'auth/signup/begin'
export const SIGN_UP_ERROR = 'auth/signup/error'
export const SIGN_UP_SUCCESS = 'auth/signup/success'

export const SIGN_IN = 'auth/signin'
export const SIGN_IN_BEGIN = 'auth/signin/begin'
export const SIGN_IN_ERROR = 'auth/signin/error'
export const SIGN_IN_SUCCESS = 'auth/signin/success'

export const SIGN_IN_MAGIC = 'auth/signin/magic'
export const SIGN_IN_MAGIC_BEGIN = 'auth/signin/magic/begin'
export const SIGN_IN_MAGIC_ERROR = 'auth/signin/magic/error'
export const SIGN_IN_MAGIC_SUCCESS = 'auth/signin/magic/success'

export const SIGN_OUT = 'auth/signout'
export const SIGN_OUT_BEGIN = 'auth/signout/begin'
export const SIGN_OUT_ERROR = 'auth/signout/error'
export const SIGN_OUT_SUCCESS = 'auth/signout/success'
